import React from 'react'
import DateFormat from '../../shared/helpers/date-format'

const { monthYear } = DateFormat

export function CalendarCaption({ classNames, date }) {
  return <h2 className={classNames.caption}>{monthYear(date)}</h2>
}
